import { useEffect, useState } from 'react';

const API = process.env.REACT_APP_BACKEND_URL;

let cached = null;
let inflight = null;

/** One-shot fetch of public feature flags (madame-files on/off, etc). Cached
 *  in-memory for the tab so multiple mount points don't spam the endpoint. */
export const useSiteFlags = () => {
  const [flags, setFlags] = useState(cached);
  useEffect(() => {
    if (cached) { setFlags(cached); return; }
    if (!inflight) {
      inflight = fetch(`${API}/api/experiences/status`)
        .then((r) => (r.ok ? r.json() : null))
        .catch(() => null)
        .then((exp) => {
          cached = { madameFilesEnabled: exp ? exp.section_enabled !== false : true };
          return cached;
        });
    }
    inflight.then((c) => setFlags(c));
  }, []);
  return flags || { madameFilesEnabled: true };
};
